import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35867a88"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "menu-div column"
}
const _hoisted_2 = {
  class: "column justify-between",
  style: {"height":"100%"}
}
const _hoisted_3 = { class: "q-pa-md" }
const _hoisted_4 = { class: "row justify-center q-mb-lg" }
const _hoisted_5 = { class: "row justify-center items-center text-subtitle1 q-mb-md" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("| ")
const _hoisted_7 = {
  class: "q-pa-xs column",
  style: {"gap":"10px","min-height":"400px"}
}
const _hoisted_8 = { class: "menu-link" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "menu-link" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "menu-link" }
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showMenu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_scroll_area, { style: {"height":"100vh"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    style: {"text-decoration":"none","cursor":"pointer"},
                    onClick: _cache[0] || (_cache[0] = () => _ctx.reloadPage())
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_q_img, {
                        src: require('@/assets/bbraun-logo.png'),
                        "spinner-color": "white",
                        width: "50%",
                        fit: "cover"
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_q_icon, { name: "language" }),
                    _createElementVNode("div", {
                      class: "q-mx-md lang-btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('de')))
                    }, "de"),
                    _hoisted_6,
                    _createElementVNode("div", {
                      class: "q-mx-md lang-btn",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('fr')))
                    }, "fr")
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: "menu-link",
                      onClick: _cache[3] || (_cache[3] = () => { _ctx.$router.push('/home'); _ctx.closeMenu() })
                    }, [
                      _createVNode(_component_q_icon, {
                        class: "q-mr-sm q-pb-xs",
                        name: "home"
                      }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("Header.FirstNavBar.HomeButton")), 1)
                    ]),
                    _createVNode(_component_q_separator),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_q_icon, {
                        class: "col-1 q-mr-sm q-pb-xs",
                        name: "medical_services"
                      }),
                      _createElementVNode("a", {
                        href: 'https://www.bbraun.ch/' + (_ctx.$i18n.locale === 'fr' ? 'fr' : 'de') + '/produkte-und-therapien.html',
                        class: "text-dark col ellipsis",
                        style: {"text-decoration":"none"}
                      }, _toDisplayString(_ctx.$t("Header.SecondNavBar.ProdukteUndTherapienButton")), 9, _hoisted_9)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_q_icon, {
                        class: "col-1 q-mr-sm q-pb-xs",
                        name: "auto_stories"
                      }),
                      _createElementVNode("a", {
                        href: 'https://www.bbraun.ch/' + (_ctx.$i18n.locale === 'fr' ? 'fr' : 'de') + '/stories.html',
                        class: "text-dark col ellipsis",
                        style: {"text-decoration":"none"}
                      }, _toDisplayString(_ctx.$t("Header.SecondNavBar.StoriesButton")), 9, _hoisted_11)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_q_icon, {
                        class: "col-1 q-mr-sm q-pb-xs",
                        name: "business"
                      }),
                      _createElementVNode("a", {
                        href: 'https://www.bbraun.ch/' + (_ctx.$i18n.locale === 'fr' ? 'fr' : 'de') + '/unternehmen.html',
                        class: "text-dark col ellipsis",
                        style: {"text-decoration":"none"}
                      }, _toDisplayString(_ctx.$t("Header.SecondNavBar.Companies")), 9, _hoisted_13)
                    ]),
                    _createVNode(_component_q_separator),
                    (_ctx.$router.currentRoute.value.name !== 'login' && _ctx.$router.currentRoute.value.name !== 'reset-password' && _ctx.$router.currentRoute.value.name !== 'privacy')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "menu-link text-secondary",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                        }, [
                          _createVNode(_component_q_icon, {
                            class: "q-mr-sm q-pb-xs",
                            name: "logout"
                          }),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Header.FirstNavBar.LogoutButton")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "menu-side",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
        }))
      : _createCommentVNode("", true)
  ]))
}